module.exports = {
	"header": "Spotin article: Companies missing content commerce sales opportunities",
	"date": "2021/12/03",
	"imgSrc": "11.jpg",
	"imgAlt": "Spotin article: Companies missing content commerce sales opportunities",
	"ingress": "By: Modern Retail (in English)",
	"externalLink": "https://modernretail.co.uk/survey-companies-missing-content-commerce-sales-opportunities/"
};


//////////////////
// WEBPACK FOOTER
// ./pages/media/11/article.json
// module id = 82
// module chunks = 0